import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Header from '../Header/Header';
import Navbar from '../NavBar/NavBar';
import { LayoutProvider, useLayout } from './LayoutContext';
import './PageLayout.css';

function PageLayoutInner() {
  const { sidebarCollapsed, closeSidebar, isMobile } = useLayout();
  const location = useLocation();
  const isHome = location.pathname === '/home';
  const showSidebar = !isHome;

  return (
    <div
      className={`app-shell${sidebarCollapsed ? ' sidebar-collapsed' : ''}${isMobile ? ' is-mobile' : ''}${isHome ? ' no-sidebar' : ''}`}
    >
      {showSidebar && isMobile && !sidebarCollapsed && (
        <button
          type="button"
          className="app-sidebar-backdrop"
          onClick={closeSidebar}
          aria-label="Close menu"
        />
      )}
      {showSidebar && <Navbar />}
      <Header showSidebar={showSidebar} />
      <main className="page-layout-main">
        <Outlet />
      </main>
    </div>
  );
}

function PageLayout() {
  return (
    <LayoutProvider>
      <PageLayoutInner />
    </LayoutProvider>
  );
}

export default PageLayout;
